import httpRequest from "../utils/axios.js";
import config from "./config.js";

export default {
    addCar,
    getCarInfo,
    deleteOneCar,
    getCarList,
    setCarDefault,
    getDecetionList,
}

/**
 * 获取当前用户所有车辆
 * @returns 
 */
export function getCarList() {
    var url = '/api/v1.0/wechat/car/getCarList'
    var jsondata = {}
    return httpRequest.fetchGet(url, jsondata)
}

/**
 * 添加或修改车辆
 */
export function addCar(carId, carNo, carEngine, carIdentification, carType, carOwnerName, carModel, carSignDate, carCertificateDate) {
    var url = '/api/v1.0/wechat/car/'
    var jsondata = {
        carNo: carNo,
        carEngine: carEngine,
        carIdentification: carIdentification,
        carType: carType,
        carOwnerName: carOwnerName,
        carModel: carModel,
        carSignDate: carSignDate,
        carCertificateDate: carCertificateDate
    }
    if (carId != undefined && carId != '') {
        jsondata.carId = carId
        url += "updateCar"
        return httpRequest.fetchPatch(url, jsondata)
    } else {
        url += "addCar"
        return httpRequest.fetchPost(url, jsondata)
    }
}

/**
 * 获取某辆车详细信息
 */
export function getCarInfo(carId) {
    var url = '/api/v1.0/wechat/car/getOneCar/' + carId
    var jsondata = {}
    return httpRequest.fetchGet(url, jsondata)
}

/**
 * 删除一辆车
 */
export function deleteOneCar(cardId) {
    var url = '/api/v1.0/wechat/car/deleteCar/' + cardId
    var jsondata = {}
    return httpRequest.fetchDelete(url, jsondata)
}

/**
 * 设置车辆为默认
 */
export function setCarDefault(cardId) {
    var url = '/api/v1.0/wechat/car/setCarDefault/' + cardId
    var jsondata = {}
    return httpRequest.fetchPatch(url, jsondata)
}

/**
 * 获取年审检测站列表
 */
export function getDecetionList(carType, longitude, latitude) {
    var url = config.getDecetionList;
    var jsondata={
      carType: carType,
      lng: longitude,
      lat: latitude,
    };
    return httpRequest.fetchGet(url, jsondata)
  } 
